<template>
  <div>
  <!-- Loader -->
  <portal to="loaderTarget">
    <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
      <gd-loader :label="$t('frontend_loading')"/>
    </div>
  </portal>
  
  <div class="flex mb-4">
    <div class="w-full bg-white  text-left">
      <div class="flex border-b border-grey-500 p-4">
        <div class="w-full">
          <p class="text-grey-700 font-semibold text-lg">
            {{ $t('frontend_groovemail_contacts_step3_revise_the') }}
          </p>
        </div>
      </div>
      <div class="left_content">
        <div class="single-row">
          <div class="icon">
            <span
              ><i
                class="text-primary fa fa-user-check"
                aria-hidden="true"
              ></i
            ></span>
          </div>
          <div class="content">
            <p class="counttotal">{{ this.localModel.uploaded }}</p>
            <p class="counttitle">
              {{ $t('frontend_groovemail_contacts_step3_uploaded') }}
            </p>
          </div>
        </div>
        <div class="single-row">
          <div class="icon">
            <span
              ><i
                class="text-primary  fa fa-user-minus"
                aria-hidden="true"
              ></i
            ></span>
          </div>
          <div class="content">
            <p class="counttotal"></p>
            <p class="counttotal">{{ this.localModel.failed }}</p>
            <p class="counttitle">
              {{ $t('frontend_groovemail_contacts_step3_failed') }} 
            </p>
          </div>
        </div>
        <div class="single-row">
          <div class="icon">
            <span
              ><i
                class="text-primary  fa fa-user-friends"
                aria-hidden="true"
              ></i
            ></span>
          </div>
          <div class="content">
            <p class="counttotal">{{ this.localModel.duplicated }}</p>
            <p class="counttitle">
              {{ $t('frontend_groovemail_contacts_step3_duplicated') }}
            </p>
          </div>
        </div>
        <div class="single-row">
          <div class="icon">
            <span
              ><i
                class="text-primary  fa fa-user-times"
                aria-hidden="true"
              ></i
            ></span>
          </div>
          <div class="content">
            <p class="counttotal">{{ this.localModel.blocked }}</p>
            <p class="counttitle">
              {{ $t('frontend_groovemail_contacts_step3_blocked') }}
            </p>
          </div>
        </div>
        <div class="single-row">
          <div class="icon">
            <span
              ><i
                class="text-primary  fa fa-user-lock"
                aria-hidden="true"
              ></i
            ></span>
          </div>
          <div class="content">
            <p class="counttotal">{{ this.localModel.alreadyexisitng }}</p>
            <p class="counttitle">
              {{ $t('frontend_groovemail_contacts_step3_already_existing') }}
            </p>
          </div>
        </div>
      </div>
      <div class="right_content">
        <div class="icon">
          <span
            ><i
              class="text-primary  fa fa-check-circle"
              aria-hidden="true"
            ></i
          ></span>
        </div>
        <div class="content">
          <p class="counttotal">
            <span class="improttotal">{{ this.localModel.imported }}</span> 
            {{ $t('frontend_groovemail_contacts_step3_records_willbe') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
export default {
  name: 'step3',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
    };
  },
  validations: {
    localModel: {
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      var isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  }
};
</script>

